/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Date_This_QuarterInputs */

const en_date_this_quarter = /** @type {(inputs: Date_This_QuarterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This Quarter`)
};

/**
* | output |
* | --- |
* | "This Quarter" |
*
* @param {Date_This_QuarterInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const date_this_quarter = /** @type {((inputs?: Date_This_QuarterInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Date_This_QuarterInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_date_this_quarter(inputs)
});